import React, { createContext, useState, useEffect } from 'react';
import { isUserAuthenticated } from '../utils/user.utils';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isUserAuthenticated()) {
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
        }
        setIsLoading(false)
    }, []);

    return (
        <AuthContext.Provider value={{ isLoggedIn, isLoading, setIsLoggedIn, setIsLoading }}>
            {children}
        </AuthContext.Provider>
    );
};